var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anchor-container"},[_c('iframe',{staticStyle:{"border":"0px","border-radius":"10px","width":"1500px","height":"800px"},attrs:{"src":_vm.iframeSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }